import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getMethod } from "../../store/actions";
import BuyerSalerTable from "./BuyerSalerTable";

const BuyerSaler = () => {
  const [buyersaler, setbuyersaler] = useState(null);
  const dispatch = useDispatch();
  const { id } = useParams();


  useEffect(() => {
    const res = dispatch(
      getMethod(
        `topsellers`, { contract_address: id }
      )
    )
      .then((res) => {
        if (res.isSuccess) {
          setbuyersaler(res.data);
        }
      })
      .catch((res) => console.log(res));
  }, []);

  return (
    <div className="tab-pane" id="tabs-5" role="tabpanel">
      <div className="chart-box bg-white pb-5">
        <div className="row">
          <div className="col-lg-6 mb-lg-0 mb-4">
            <h3 className="pb-3 pb-md-5">Top buyers (Last 3 Days)</h3>
            <div className="site-table mobile-table">
              <BuyerSalerTable
                Header={["Buyer address", "Sale in dollars (ETH)", "Purchases"]}
                body={buyersaler?.Topbuyers || null}
                type={"buyer"}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <h3 className="pb-3 pb-md-5">Top Sellers (Last 3 Days)</h3>
            <div className="site-table mobile-table">
              <BuyerSalerTable
                Header={["Seller address", "Sale in dollars (ETH)", "Sales"]}
                body={buyersaler?.TopSellers || null}
                type={"seller"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyerSaler;
